// GetFrontPageThumbnails.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { globals } from '../globals';
import { useSettings } from '../context/SettingsContext';
import ContactSheetFolders from './ContactSheetFolders';

function GetFrontPageThumbnails() {
  const [folders, setFolders] = useState([]);
  const [loadingGallery, setloadingGallery] = useState(true);
  const [error, setError] = useState(null);
  const { settings, loading } = useSettings();

  useEffect(() => {
    if (!loading && settings.galleriesInHomepage) {
      axios.get(`${globals.homepageUrl}/php/get-folders-from-db.php?limit=${settings.galleriesInHomepage}`)
        .then(response => {
          setFolders(response.data);
          setloadingGallery(false);
        })
        .catch(error => {
          console.error('Errore durante il caricamento delle cartelle:', error);
          setError('Errore durante il caricamento delle cartelle.');
          setloadingGallery(false);
        });
    }
  }, [settings, loading]);

  if (loadingGallery) {
    return <p>Caricamento in corso...</p>;
  }

  if (error) {
    return <p>{error}</p>;
  }

  return <ContactSheetFolders folders={folders} />;
}

export default GetFrontPageThumbnails;
